module.exports = __webpack_public_path__ + "static/media/detail-shirt-1960.de367ca1.png";